(function () {
  if (window.__hpCardMediaLink) return;
  window.__hpCardMediaLink = true;
  ['click', 'auxclick'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      var card = a.closest('.card-wrapper');
      if (!card) return;
      var imgs = card.querySelectorAll('.card__media .media img[data-media-id]');
      if (!imgs.length) return;
      var chosen = imgs[0];
      for (var i = imgs.length - 1; i > 0; i--) {
        if (parseFloat(getComputedStyle(imgs[i]).opacity) > 0.5) { chosen = imgs[i]; break; }
      }
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        url.searchParams.set('media', chosen.dataset.mediaId);
        a.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (err) {}
    }, true);
  });
})();
